import { Directive } from '@angular/core';

@Directive({
    selector: '[appMapname]',
    standalone: false
})
export class MapnameDirective {

  constructor() { }

}
